















import { computed, defineComponent } from '@vue/composition-api';
import { useMessageStore } from '@/stores/message';
import { Message, MessageType } from '@/model/store';

export default defineComponent({
  name: 'Messages',
  props: {
    errors: Boolean,
    warnings: Boolean,
    infos: Boolean,
  },
  setup(props) {
    const messageStore = useMessageStore();
    const filterTypes = computed<MessageType[]>(
      () =>
        [
          props.errors && MessageType.error,
          props.warnings && MessageType.warning,
          props.infos && MessageType.info,
        ].filter((type) => type !== false) as MessageType[]
    );
    const messages = computed<Message[]>(() =>
      messageStore.messages.filter((msg) => !filterTypes.value.length || filterTypes.value.includes(msg.type))
    );
    const close = (id: string) => {
      messageStore.removeMessage(id);
    };

    return {
      messages,
      close,
    };
  },
});
